import { ArrowUpRight, MapPin, MessageCircle, Clock } from "lucide-react";
import { waLink, WA_NUMBER } from "../../lib/wa";

export const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            data-testid="site-footer"
            className="bg-jws-text text-jws-bg pt-20 md:pt-32 pb-10 relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="text-xs uppercase tracking-[0.3em] text-jws-bg/50 mb-8">
                    (07) Mari mulai
                </div>

                <h2
                    data-testid="footer-headline"
                    className="font-display font-bold tracking-[-0.04em] leading-[0.95] text-[2.5rem] sm:text-6xl md:text-[8rem] lg:text-[10rem]"
                >
                    Mari diskusikan
                    <br />
                    proyek{" "}
                    <span className="italic font-light text-jws-ochre">
                        anda
                    </span>
                    .
                </h2>

                <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
                    <div className="col-span-1 md:col-span-7">
                        <a
                            href={waLink()}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-wa-cta"
                            className="btn-arrow group inline-flex items-center gap-3 md:gap-4 rounded-full bg-jws-primary text-white pl-5 md:pl-7 pr-2 md:pr-3 py-2.5 md:py-3 hover:bg-jws-primaryHover transition-all hover:-translate-y-0.5"
                        >
                            <span className="font-display text-base md:text-2xl tracking-tight">
                                Chat WhatsApp sekarang
                            </span>
                            <span className="h-10 w-10 md:h-12 md:w-12 grid place-items-center rounded-full bg-jws-bg text-jws-primary shrink-0">
                                <ArrowUpRight className="h-4 w-4 md:h-5 md:w-5" />
                            </span>
                        </a>

                        <p className="mt-6 text-jws-bg/60 max-w-md leading-relaxed text-sm md:text-base">
                            Konsultasi awal gratis. Cerita saja kebutuhan anda
                            — kami bantu petakan solusi paling masuk akal.
                        </p>
                    </div>

                    <div className="col-span-1 md:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-8 md:pt-2">
                        <div data-testid="footer-contact-wa">
                            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-jws-bg/50">
                                <MessageCircle className="h-4 w-4" /> WhatsApp
                            </div>
                            <a
                                href={waLink()}
                                target="_blank"
                                rel="noreferrer"
                                className="mt-3 block font-display text-2xl tracking-tight hover:text-jws-ochre transition-colors"
                            >
                                +62 851-9082-4646
                            </a>
                        </div>
                        <div data-testid="footer-contact-location">
                            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-jws-bg/50">
                                <MapPin className="h-4 w-4" /> Studio
                            </div>
                            <p className="mt-3 font-display text-2xl tracking-tight leading-tight">
                                Abepura,
                                <br />
                                Jayapura — Papua
                            </p>
                        </div>
                        <div className="col-span-1 sm:col-span-2">
                            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-jws-bg/50">
                                <Clock className="h-4 w-4" /> Jam respon
                            </div>
                            <p className="mt-3 text-jws-bg/80">
                                Senin – Sabtu · 09:00 – 21:00 WIT
                                <br />
                                <span className="text-jws-bg/50 text-sm">
                                    Pesan di luar jam akan dibalas secepatnya.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-jws-bg/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-jws-bg/50">
                    <div>
                        © {year} Jayapura Web Studio. Dibuat dengan teliti
                        di Abepura.
                    </div>
                    <div className="flex items-center gap-6">
                        <a
                            href={waLink()}
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-jws-bg transition-colors"
                            data-testid="footer-link-wa"
                        >
                            WhatsApp
                        </a>
                        <a
                            href={`tel:+${WA_NUMBER}`}
                            className="hover:text-jws-bg transition-colors"
                            data-testid="footer-link-tel"
                        >
                            Telpon
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
